import { ClientService, ToastMessageService } from '@fitness-force/api';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, AbstractControl, ValidationErrors } from '@angular/forms';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject } from 'rxjs';
import {  ShortNamePipe} from '@fitness-force/pipes/short-name'
@Component({
  selector: 'delete-digital-pass',
  templateUrl: './delete-digital-pass.component.html',
  providers: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [    CommonModule,
    SelectModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    AvatarModule,
    ButtonModule,
    RippleModule,
    BlockUIModule,
    StyleClassModule,
    InputTextModule,
    PasswordModule,
    ShortNamePipe,
    AvatarModule,
    TranslateModule,
    ErrorMsgComponent
  ],
})
export class DeleteDigitalPassComponent implements OnInit, OnDestroy {
  @Input() deleteDigitalPassModal: boolean | null = false;
  @Input() clientData$: any = new BehaviorSubject(null)
  @Output() closeDeleteDigitalPassDialog = new EventEmitter()

  deleteDigitalPassFromGroup: UntypedFormGroup = new UntypedFormGroup({});

  allClientData: any;
  btnLoading:boolean=false;
  constructor(private fb: UntypedFormBuilder,
     public translate: TranslateService,
      private clientService: ClientService, 
      private toastMessageService: ToastMessageService,
      private cd: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.componentInit()
  }

  componentInit() {
    this.deleteDigitalPassFromGroup = this.fb.group({
      confirmationText: [''],
      confirmationDescription: [''],
      clientName: []
    })
    this.clientData$.subscribe(
      (client: any) => {
        this.allClientData = client

        // Set validation to check for exact match with 'Delete Access Pass'
        this.ConfirmationText.setValidators([Validators.required, this.deleteAccessPassValidator]);
        this.ClientName.setValue(this.allClientData.full_name)
      })


  }
  closeDialogEvent(action: string | null = null) {
    this.deleteDigitalPassFromGroup.reset();
    this.closeDeleteDigitalPassDialog.emit({ close: true, action })
  }

  deleteDigitalPass() {
    this.btnLoading=true;
    let tenantid=0;
    if(this.allClientData.home_club_tenant_id && this.allClientData.home_club_tenant_id > 0) tenantid = this.allClientData.home_club_tenant_id;
    else tenantid= this.allClientData.createdin_tenant_id;
   
      this.clientService.deleteDigitalKeyFob(tenantid, this.allClientData.id).subscribe({
        next: (res: any) => {
          this.translate.get('DELETE_DIGITAL_PASS.SUCCESS').subscribe((translations: any) => {
            this.toastMessageService.showSuccess(translations);
          });
          this.btnLoading=false;
          this.closeDialogEvent("delete");
          this.cd.detectChanges();
        },
        error: (error) => {
         this.btnLoading=false;
         this.toastMessageService.showError(error);
         this.cd.detectChanges();
        }
      })
  }

  get ConfirmationText(): UntypedFormControl {
    return this.deleteDigitalPassFromGroup.get('confirmationText') as UntypedFormControl;
  }
  
  get ConfirmationDescription(): UntypedFormControl {
    return this.deleteDigitalPassFromGroup.get('confirmationDescription') as UntypedFormControl;
  }

  get ClientName(): UntypedFormControl {
    return this.deleteDigitalPassFromGroup.get('clientName') as UntypedFormControl;
  }

  ngOnDestroy(): void {
    this.deleteDigitalPassFromGroup.reset();
  }

  /**
   * Custom validator function that checks if input matches 'Delete Access Pass' exactly
   */
  deleteAccessPassValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // Let required validator handle empty values
    }
    
    const isValid = control.value.toLowerCase() === 'delete access pass';
    return isValid ? null : { invalidConfirmationText: true };
  }

}